import { createApp } from 'vue'
// import App from './App.vue'
// import DeepZoomSample from "@/views/DeepZoomSample";
import AppView from "./App";
import router from './router'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap'
import 'axios'
createApp(AppView).use(router).mount('#app')
